// extracted by mini-css-extract-plugin
export var label = "_7u-1";
export var reminder = "_7u-0";